import { render, staticRenderFns } from "./thead.vue?vue&type=template&id=2d6246d8&scoped=true"
import script from "./thead.vue?vue&type=script&lang=ts"
export * from "./thead.vue?vue&type=script&lang=ts"
import style0 from "./thead.vue?vue&type=style&index=0&id=2d6246d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6246d8",
  null
  
)

export default component.exports